module.exports = __webpack_public_path__ + "img/imagen9.4c9092c7.png";